import { Navigate } from "react-router-dom";
import { getToken, isValidToken } from "../utils";

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const token = getToken();
  return isValidToken(token) ? children : <Navigate to="/login" />;
};
